export function analyzeRatings(ratings) {
  if (!ratings) return { numRatings: 0, avgRating: 0 }
  let total = 0
  let sum = 0
  for (let i = 1; i <= 5; i++) {
    total += ratings[i] || 0
    sum += i * (ratings[i] || 0)
  }
  return { numRatings: total, avgRating: total > 0 ? sum / total : 0 }
}

export function calculateRatingDistribution(ratings) {
  const distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }
  const percentages = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }
  if (!ratings) return { distribution, percentages, total: 0 }

  let total = 0
  for (let i = 1; i <= 5; i++) {
    distribution[i] = ratings[i] || 0
    total += distribution[i]
  }
  for (let i = 1; i <= 5; i++) {
    percentages[i] = total > 0 ? Math.round((distribution[i] / total) * 100) : 0
  }
  return { distribution, percentages, total }
}
